import React from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'

const SkeletonLoader = ({
  variant = "text",
  animation = "pulse",
  width = "100%",
  height,
  count,
  className = "",
}) => {
  return (
      <Skeleton variant={variant} count={count} animation={animation} width={width} height={height} />
  );
};

export default SkeletonLoader;